import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { useFormik } from 'formikV2';
import { didSucceed, useTwoFactorMutation } from './useChallengeMutation';
import { ChallengeSchema } from './validationSchema';
export var CHALLENGE_RESULT;

(function (CHALLENGE_RESULT) {
  CHALLENGE_RESULT[CHALLENGE_RESULT["success"] = 0] = "success";
  CHALLENGE_RESULT[CHALLENGE_RESULT["failure"] = 1] = "failure";
  CHALLENGE_RESULT[CHALLENGE_RESULT["default"] = 2] = "default";
})(CHALLENGE_RESULT || (CHALLENGE_RESULT = {}));

var useChallengeForm = function useChallengeForm(_ref) {
  var email = _ref.email,
      password = _ref.password,
      challengeId = _ref.challengeId;

  var _useTwoFactorMutation = useTwoFactorMutation(),
      initChallengeMutation = _useTwoFactorMutation.initChallengeMutation,
      loading = _useTwoFactorMutation.loading;

  var _useState = useState(CHALLENGE_RESULT["default"]),
      _useState2 = _slicedToArray(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var handleFormSubmission = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var challengeAnswer, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              challengeAnswer = _ref2.challengeAnswer;
              _context.next = 3;
              return initChallengeMutation(email, password, challengeId, challengeAnswer);

            case 3:
              data = _context.sent;

              if (didSucceed(data)) {
                setData(data);
                setResult(CHALLENGE_RESULT.success);
              } else {
                setResult(CHALLENGE_RESULT.failure);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFormSubmission(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var _useFormik = useFormik({
    initialValues: {
      challengeAnswer: ''
    },
    onSubmit: handleFormSubmission,
    validationSchema: ChallengeSchema
  }),
      errors = _useFormik.errors,
      handleChange = _useFormik.handleChange,
      handleSubmit = _useFormik.handleSubmit,
      values = _useFormik.values;

  return {
    errors: errors,
    data: data,
    handleChange: handleChange,
    handleSubmit: handleSubmit,
    loading: loading,
    result: result,
    values: values
  };
};

export { useChallengeForm };